import React, { useState, useEffect } from 'react';

const Clearpay = ({ data, currency }) => {
  const [clearpayProdPrice, setclearpayProdPrice] = useState(null);
  //console.log(data);
  useEffect(() => {
    if (data.product.option.onsale) {
      setclearpayProdPrice(data.product.option.promotionpriceasnumber);
    } else {
      setclearpayProdPrice(data.product.option.priceasnumber);
    }

    const clearpayScript = document.createElement('script');
    clearpayScript.src = 'https://js.afterpay.com/afterpay-1.x.js';
    document.head.appendChild(clearpayScript);
    return () => {
      document.head.removeChild(clearpayScript);
    };
  }, [
    data.product.option.onsale,
    data.product.option.priceasnumber,
    data.product.option.promotionpriceasnumber
  ]);

  return (
    <div className="clearpay-widget">
      <span className="clearpay-logo-wrapper">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69 34.5">
          <rect width={69} height={34.5} rx={4.182} ry={4.182} fill="#f5f5f5" />
          <path d="m60.583 14.77-1.574-.903-1.597-.917a1.588 1.588 0 0 0-2.379 1.377v.209c0 .113.06.217.158.273l.741.425a.314.314 0 0 0 .462-.268v-.487a.314.314 0 0 1 .47-.272l1.464.836 1.455.836a.314.314 0 0 1 0 .545l-1.455.836-1.464.836a.313.313 0 0 1-.47-.272v-.242a1.589 1.589 0 0 0-2.379-1.377l-1.597.917-1.574.903a1.588 1.588 0 0 0 0 2.755l1.574.903 1.597.917a1.588 1.588 0 0 0 2.379-1.378v-.209a.314.314 0 0 0-.158-.273l-.741-.425a.314.314 0 0 0-.462.268v.487a.314.314 0 0 1-.47.272l-1.464-.836-1.455-.836a.314.314 0 0 1 0-.545l1.455-.836 1.464-.836a.313.313 0 0 1 .47.272v.242a1.589 1.589 0 0 0 2.379 1.377l1.597-.917 1.574-.903a1.588 1.588 0 0 0 0-2.754Zm-10.336.305-3.694 7.623H45.02l1.38-2.849-2.169-4.775h1.568l1.394 3.198 1.523-3.198h1.531Zm-7.897 2.706a1.474 1.474 0 1 0 .002.064c0-.021 0-.043-.002-.064m.01 2.707v-.704a2.17 2.17 0 0 1-1.71.79 2.643 2.643 0 0 1-2.614-2.794 2.692 2.692 0 0 1 2.577-2.802l.064-.002a2.158 2.158 0 0 1 1.678.78v-.682h1.332v5.413h-1.328Zm-6.178-2.707a1.473 1.473 0 1 0-1.463 1.545 1.499 1.499 0 0 0 1.474-1.524v-.024m-4.286 4.914v-7.623h1.332v.704a2.145 2.145 0 0 1 1.71-.801 2.662 2.662 0 0 1 2.613 2.793 2.692 2.692 0 0 1-2.577 2.802l-.064.002a2.091 2.091 0 0 1-1.635-.726v2.849h-1.379ZM29.5 15.606a1.418 1.418 0 0 1 1.754-.506v1.381a1.717 1.717 0 0 0-.961-.247.953.953 0 0 0-.75 1.045v3.205h-1.375v-5.413H29.5v.534Zm-3.554 4.88v-.704c-.42.51-1.049.801-1.709.789a2.641 2.641 0 0 1-2.612-2.67c0-.041.002-.081.004-.122a2.689 2.689 0 0 1 2.573-2.8l.067-.002a2.158 2.158 0 0 1 1.673.779v-.682h1.331v5.41h-1.327Zm-.01-2.705a1.473 1.473 0 1 0-1.471 1.547 1.48 1.48 0 0 0 1.472-1.485c0-.021 0-.043-.002-.064v.002Zm-9.024.356a1.347 1.347 0 0 0 1.396 1.255 1.435 1.435 0 0 0 1.277-.704h1.396a2.823 2.823 0 0 1-5.485-.898 2.797 2.797 0 1 1 5.594 0c0 .116-.01.232-.032.346h-4.144Zm2.718-.843a1.296 1.296 0 0 0-1.341-1.125 1.338 1.338 0 0 0-1.359 1.125h2.7Zm-6.129 3.19v-7.632h1.359v7.632h-1.359Zm-.634-2.013a2.822 2.822 0 0 1-5.551-.692 2.76 2.76 0 0 1 2.717-2.802h.106a2.718 2.718 0 0 1 2.718 2.077h-1.406a1.47 1.47 0 0 0-1.298-.811 1.538 1.538 0 0 0 0 3.073 1.425 1.425 0 0 0 1.309-.844h1.405Z" />
        </svg>
      </span>
      <afterpay-placement
        data-locale="en_GB"
        data-currency={currency}
        data-amount={clearpayProdPrice}
        data-logo-type="lockup"
        data-size="sm"
      />
    </div>
  );
};

export default Clearpay;
